module.exports = __webpack_public_path__ + "static/media/Battery-white.01c3ca2e.svg";